import { Cursor } from '@robocorp/robocloud-search-iternal-sdk';
import { AssistantRunActionType, AssistantRunAction } from '../../actions/assistantRunActions';

type PaginationState = null | {
  nextCursor: Cursor;
  previousCursor: Cursor;
  total: number;
};

const PagingReducer = (state: PaginationState = null, action: AssistantRunAction) => {
  switch (action.type) {
    case AssistantRunActionType.LIST_ASSISTANT_RUNS_OK:
      if (!action) return null;
      return {
        nextCursor: action.data.nextCursor,
        previousCursor: action.data.previousCursor,
        total: action.data.total,
      };
    default:
      return state;
  }
};

export default PagingReducer;
